/**
 * VIP (10.6S/U) — REGALIAS por TIER (permanente) + PASSE (30 dias).
 * Tier 0 = sem VIP. Tier 1–3 = Bronze/Prata/Ouro (comprado com 💎 in-game).
 * Passe = assinatura temporária que MULTIPLICA XP/moedas (em cima do tier).
 * As regalias melhoram recompensas, sem pay-to-win forte.
 */
import { GameConfig } from "../config/GameConfig";

export const Vip = {
  _tier: 0,
  _passExpiresAt: 0,

  setTier(t: number): void {
    this._tier = Math.max(0, Math.min(GameConfig.vipTiers.length, t));
  },
  setPassExpiresAt(ts: number): void {
    this._passExpiresAt = Math.max(0, ts);
  },

  get tier(): number { return this._tier; },
  get active(): boolean { return this._tier > 0; },
  get passActive(): boolean { return this._passExpiresAt > Date.now(); },
  get passRemainingMs(): number { return Math.max(0, this._passExpiresAt - Date.now()); },

  get tierConfig() {
    return this._tier > 0 ? GameConfig.vipTiers[this._tier - 1] : null;
  },

  get dropRarityBoost(): boolean {
    return this.active && (this.tierConfig?.perks.dropRarityBoost ?? false);
  },
  get absorbMult(): number {
    return this.active ? (this.tierConfig?.perks.absorbMult ?? 1) : 1;
  },
  get essenceMult(): number {
    return this.active ? (this.tierConfig?.perks.essenceMult ?? 1) : 1;
  },
  /** 10.9BO — quem diz em que região o player está (o Game liga no boot). */
  regionProvider: null as (() => string) | null,
  /** 10.9BO — bônus de XP da ÁREA VIP da região atual (a área é a região inteira enquanto o tier a destrava). */
  get areaXpMult(): number {
    const rid = this.regionProvider?.();
    if (!rid || !this.active) return 1;
    const zone = GameConfig.vipAreas.zones.find((z) => z.regionId === rid);
    return zone && this.hasArea(zone.id) ? zone.xpMult : 1;
  },
  get xpMult(): number {
    const tier = this.active ? (this.tierConfig?.perks.xpMult ?? 1) : 1;
    const pass = this.passActive ? GameConfig.vipPass.xpMult : 1;
    return tier * pass * this.areaXpMult; // teto global em XPSystem (progression.xpMultCap)
  },
  get coinMult(): number {
    const tier = this.active ? (this.tierConfig?.perks.coinMult ?? 1) : 1;
    const pass = this.passActive ? GameConfig.vipPass.coinMult : 1;
    return tier * pass;
  },
  get dailyDiamonds(): number {
    const tier = this.active ? (this.tierConfig?.perks.dailyDiamonds ?? 0) : 0;
    const pass = this.passActive ? GameConfig.vipPass.dailyDiamonds : 0;
    return tier + pass;
  },
  /** 10.9J7 — bônus GRÁTIS de espaço de bolsa por tier (conveniência, não poder de combate).
   *  Substitui o antigo "weaponSlot" (+1 arma na Corrente por 💎, removido — ver GameConfig.ts). */
  get bagBonus(): number {
    return this.active ? (this.tierConfig?.perks.bagBonus ?? 0) : 0;
  },
  /** 10.9L0 — +1 arma na Corrente (o 5º slot da barra): qualquer tier VIP OU o Passe VIP ativo.
   *  Decisão do Thiago: vantagem de dano pra quem é VIP (tinha saído na 10.9J7). */
  get weaponSlotUnlocked(): boolean {
    return (this.active && (this.tierConfig?.perks.weaponSlot ?? false)) || this.passActive;
  },
  hasArea(areaId: string): boolean {
    if (!this.active || !this.tierConfig) return false;
    return (this.tierConfig.areas as readonly string[]).includes(areaId);
  },
};
